import React, { useState, useEffect } from "react";
import ParticlesAuth from "../AuthenticationInner/ParticlesAuth";
import { Card, CardBody, Col, Container, Row } from "reactstrap";
import toast from "react-hot-toast";
import { useFormik } from "formik";
import AuthenticationsServices from "../../Services/AuthenticationService/AuthenticationsServices";
import * as Yup from "yup";
import { useSearchParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";

const Verification = () => {
  const [timer, setTimer] = useState(30); // Timer for resending OTP
  const [isResendDisabled, setIsResendDisabled] = useState(false);
  const [searchParams] = useSearchParams();
  const location = useLocation();


  const email = location.state?.email || ""; // Use the email from the navigate's state

  console.log("🚀 ~ Verification ~ email:", email);
const navigate= useNavigate();
  // Formik form handling
  const formik = useFormik({
    initialValues: {
      email: email || "", 
      OTP: "", 
    },
    enableReinitialize: true,
    validationSchema: Yup.object({
      email: Yup.string()
        // .email("Invalid email format")
        .required("Email is required"),
      OTP: Yup.string()
        .length(6, "OTP must be 6 digits")
        .required("OTP is required"),
    }),
    onSubmit: async (values) => {
      console.log("Form values being sent:", values);
      try {
        const response = await AuthenticationsServices.verify({
          email: values.email, 
          OTP: values.OTP 
        });
        console.log("Verification response:", response);
        localStorage.setItem("user", JSON.stringify(response));
        toast.success("OTP validated Successfully!");
        navigate("/login")
      } catch (error) {
        console.error("Error during verification:", error.response?.data);
        toast.error(
          error.response?.data?.message || "Verification error occurred"
        );
      }
    },
  });
  

  // Handle Resend OTP
  const handleResendOtp = () => {
    setIsResendDisabled(true);
    setTimer(30); // Reset the timer
    // Simulate OTP resend action (e.g., call API to resend OTP)
    toast.info("OTP has been resent!");
  };

  // Countdown for resend timer
  useEffect(() => {
    let interval;
    if (isResendDisabled && timer > 0) {
      interval = setInterval(() => {
        setTimer((prevTimer) => prevTimer - 1);
      }, 1000);
    } else if (timer === 0) {
      setIsResendDisabled(false);
    }
    return () => clearInterval(interval);
  }, [isResendDisabled, timer]);

  return (
    <React.Fragment>
      <ParticlesAuth>
        <div className="auth-page-content">
          <Container>
            <Row className="justify-content-center align-content-center align-items-center">
              <Col md={7} lg={7}>
                <Card className="mt-4">
                  <CardBody>
                    <h2>OTP Verification</h2>

                    {/* Email input */}
                    <div className="mb-3">
                      <label htmlFor="email" className="form-label">
                        Enter your email <span className="text-danger">*</span>
                      </label>
                      <input
                        type="email"
                        className={`form-control ${
                          formik.touched.email && formik.errors.email
                            ? "is-invalid"
                            : ""
                        }`}
                        id="email"
                        {...formik.getFieldProps("email")}
                        placeholder="Enter your email"
                      />
                      {formik.touched.email && formik.errors.email && (
                        <div className="invalid-feedback">
                          {formik.errors.email}
                        </div>
                      )}
                    </div>

                    {/* OTP input */}
                    <div className="mb-3">
                      <label htmlFor="OTP" className="form-label">
                        Enter OTP <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className={`form-control ${
                          formik.touched.OTP && formik.errors.OTP
                            ? "is-invalid"
                            : ""
                        }`}
                        id="OTP"
                        {...formik.getFieldProps("OTP")}
                        maxLength="6"
                        placeholder="Enter 6-digit OTP"
                      />
                      {formik.touched.OTP && formik.errors.OTP && (
                        <div className="invalid-feedback">
                          {formik.errors.OTP}
                        </div>
                      )}
                    </div>

                    {/* Submit Button */}
                    <div className="d-flex justify-content-between">
                      <button
                        type="submit"
                        className="btn btn-primary"
                        onClick={formik.handleSubmit}
                        disabled={isResendDisabled}
                      >
                        Verify OTP
                      </button>
                      <button
                        type="button"
                        className="btn btn-link"
                        onClick={handleResendOtp}
                        disabled={isResendDisabled}
                      >
                        {isResendDisabled
                          ? `Resend OTP in ${timer}s`
                          : "Resend OTP"}
                      </button>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </ParticlesAuth>
    </React.Fragment>
  );
};

export default Verification;
